import { Space, Spin } from 'antd';

import { Button } from '@atom/button/button';
import { ButtonTypeEnum } from '@atom/button/button.enum';
import { Input } from '@atom/form/input/input';
import { Text } from '@atom/typography/typography';
import { ColorEnum } from '@enum/style/color.enum';
import { Form } from '@form/common.style';
import { FormError } from '@form/form-error';
import { BaseFormInterface } from '@interface/form/base-form.interface';

import { initialUserProfileForm } from './user-profile.form-initial';
import { userProfileFormValidation } from './user-profile.form-validation';

export const UserProfileForm = ({ form, error, isLoading = false }: BaseFormInterface) => (
  <Form autoComplete='off' form={form} initialValues={initialUserProfileForm} layout='vertical' name='application'>
    <Space direction='vertical' size={15}>
      <Form.Item label='First Name' name='name' rules={[userProfileFormValidation]} validateTrigger='onBlur'>
        <Input placeholder='Joe' />
      </Form.Item>
      <Form.Item label='Last Name' name='lastname' rules={[userProfileFormValidation]}>
        <Input placeholder='Doe' />
      </Form.Item>
      <Form.Item label='Company' name='company' rules={[userProfileFormValidation]}>
        <Input placeholder='Ex: http://website.com' />
      </Form.Item>
      <Button htmlType='submit' type={ButtonTypeEnum.Primary} ghost>
        {isLoading && <Spin />}
        {!isLoading && (
          <Text color={ColorEnum.Inherit} letterSpacing={1.4}>
            Update
          </Text>
        )}
      </Button>
    </Space>
    <FormError error={error} errorField='name' />
  </Form>
);
